<template>
<div class="chapter">
<div class="inner_page">
<h4 class="calibre8" id="pgepubid00005"><a id="CHAPTER_I">I</a></h4>
<p class="center">LETTER TO MADAME CAMILLE HEUDEBERT,<br class="calibre5"/>
AT D——, VIA BLOIS.</p>
<p class="calibre11">Do not worry, dear sister, for here I am, at Paris, without accident or
fatigue. I have slept a few hours, breakfasted on a cup of coffee, made
my toilet, and, in a moment, I am going to take a carriage to Madame
d'Arglade's, that she may present me to Madame de Villemer. This evening
I will write you the result of the solemn interview, but I want first to
mail you these few words, that you may feel easy about my journey and my
health.</p>
<p class="calibre11">Take courage with me, my Camille; all will go well. God does not abandon
those who depend upon him, and who do their best to second his tender
providence. What has been saddest for me in my resolution are your
tears,—yours and the dear little ones'; it is hard for me to restrain
mine when I think of them; but you <i class="calibre12">must</i> see it was absolutely
necessary. I could not sit with folded hands when you have four children
to rear. Since I have courage and health, and no other claim upon me in
this world than that of my tenderness for you and for those poor angels,
it was for me to go forth and try to gain our livelihood. I will reach
that end, be sure. Sustain me instead of regretting me and making me
weaker; that is all I ask of you. And with this, my much-loved sister, I
embrace you and our dear children with all my heart. Do not make them
weep by speaking to them of me; but try, nevertheless, not to let them
forget me; that would pain me beyond measure.</p>
<p class="calibre13">CAROLINE DE SAINT-GENEIX.</p>
<p class="calibre14">January 3, 1845.</p>
<p class="center">SECOND LETTER.—TO THE SAME.</p>
<p class="calibre11">Victory, great victory! my good sister. I have just returned from our
great lady's, and—success unhoped for, as you shall see. Since I have
one more evening of liberty, and that probably the last, I am going to
profit by it in giving you an account of the interview. It will seem as
if I were chatting with you again at the fireside, rocking Charley with
one hand and amusing Lili with the other. Dear loves, what are they
doing at this moment? They do not imagine that I am all alone in a
melancholy room of a public house, for, in the fear of being troublesome
to Madame d'Arglade, I put up at a little hotel; but I shall be very
comfortable at the Marchioness's, and this lone evening is not a bad one
for me to collect myself and think of you without interruption. I did
well, besides, not to count too much upon the hospitality which was
offered me, because Madame d'Arglade is absent, and so I had to
introduce myself to Madame de Villemer.</p>
<p class="calibre11">You asked me to give you a description of her: she is about sixty years
old, but she is infirm and seldom leaves her arm-chair; that and her
suffering face make her look fifteen years older. She could never have
been beautiful, or comely of form; yet her countenance is expressive and
has a character of its own. She is very dark; her eyes are magnificent,
just a little hard, but frank. Her nose is straight and too nearly
approaches her mouth, which is not at all handsome. Her mouth is
ordinarily scornful; still, her whole face gleams and mellows with a
human sympathy when she smiles, and she smiles readily. My first
impression agrees with my last. I believe this woman very good by
principle rather than by impulse, and courageous rather than cheerful.
She has intelligence and cultivation. In fine, she does not differ much
from the description which Madame d'Arglade gave us of her.</p>
<p class="calibre11">She was alone when I was conducted into her apartment. Gracefully enough
she made me sit down close to her, and here is a report of our
conversation:—</p>
<p class="calibre11">"You have been highly recommended to me by Madame d'Arglade, whom I
esteem very much indeed. I know that you belong to an excellent family,
that you have talents and an honorable character, and that your life has
been blameless. I have therefore the greatest wish that we may
understand each other and agree. For that, there must be two things: one
that my offer may seem satisfactory to you; the other that our views may
not be too much opposed, as that would be the source of frequent
misunderstandings. Let us deal with the first question. I offer you
twelve hundred francs a year."</p>
<p class="calibre11">"So I have been told, Madame, and I have accepted."</p>
<p class="calibre11">"Have I not been told, too, that you would perhaps find that
insufficient?"</p>
<p class="calibre11">"It is true, that is little for the needs of my situation; but Madame is
the judge of her own affairs, and since I am here—"</p>
<p class="calibre11">"Speak frankly; you think that is not enough?"</p>
<p class="calibre11">"I cannot say that. It is probably more than my services are worth."</p>
<p class="calibre11">"I am far from saying so, and you—you say it from modesty; but you
fear that will not be enough to keep you? Do not let it trouble you; I will
take everything upon myself; you will have no expense here except for
your toilet, and in that regard I make no requirement. And do you love
dress?"</p>
<p class="calibre11">"Yes, Madame, very much; but I shall abstain from it, because in that
matter you make no requirement."</p>
<p class="calibre11">The sincerity of my answer appeared to astonish the Marchioness. Perhaps
I ought not to have spoken without restraint, as it is my habit to do.
She took a little time to collect herself. Finally she began to smile
and said, "Ah, so! why do you love dress? You are young, pretty, and
poor; you have neither the need nor the right to bedizen yourself?"</p>
<p class="calibre11">"I have so little right to do it," I answered, "that I go simply clad,
as you see."</p>
<p class="calibre11">"That is very well, but you are troubled because your toilet is not more
elegant?"</p>
<p class="calibre11">"No, Madame, I am not troubled about it at all, since it must be so. I
see that I spoke without reflection when I told you that I was fond of
dress, and that has given you a poor idea of my understanding. I pray
you to see nothing in that avowal but the effect of my sincerity. You
questioned me concerning my tastes, and I answered as if I had the honor
to be known to you; it was perhaps an impropriety, and I beg you to
pardon it."</p>
<p class="calibre11">"That is to say," rejoined she, "if I knew you, I would be aware that
you accept the necessities of your position without ill-temper and
without murmuring?"</p>
<p class="calibre11">"Yes, Madame, that is it exactly."</p>
<p class="calibre11">"Well, your impropriety, if it is one at all, is far from displeasing
me. I love sincerity above all things; I love it perhaps more than I do
understanding, and I make an appeal to your entire frankness. Now what
was it that persuaded you to accept such slight remuneration for coming
here and keeping company with an infirm and perhaps tiresome old woman?"</p>
<p class="calibre11">"In the first place, Madame, I have been told that you are very
intelligent and kind, and on that account I did not expect to find life
tiresome with you; and then, even if I should have to endure a great
deal, it is my duty to accept it all rather than to remain idle. My
father having left us no fortune, my sister was at least well enough
married, and I felt no scruples in living with her; but her husband, who
had nothing but the salary of his place, recently died after a long and
cruel illness, which had absorbed all our little savings. It therefore
naturally falls upon me to support my sister and her four children."</p>
<p class="calibre11">"With twelve hundred francs!" cried the Marchioness. "No, that cannot
be. Ah! Madame d'Arglade did not tell me that. She, without doubt,
feared the distrust which misfortune inspires; but she was very much
mistaken in my case; your self-devotion interests me, and, if we can
agree in other respects, I hope to make you sensible of my regard. Trust
in me; I will do my best."</p>
<p class="calibre11">"Ah! Madame," I replied, "whether I have the good fortune to suit you or
not, let me thank you for this good prompting of your heart." And I
kissed her hand impulsively, at which she did not seem displeased.</p>
<p class="calibre11">"Yet," continued she, after another silence, in which she appeared to
distrust her own suggestion, "what if you are slightly frivolous and a
little of a coquette."</p>
<p class="calibre11">"I am neither the one nor the other."</p>
<p class="calibre11">"I hope not. Yet you are very pretty. They did not tell me that either,
and the more I look at you, the more I think you are even remarkably
pretty. That troubles me a little, and I do not conceal it from you."</p>
<p class="calibre11">"Why, Madame?"</p>
<p class="calibre11">"Why? Yes, you are right. The ugly believe themselves beautiful, and to
the desire to please they add the faculty of making themselves ridiculous.
You would better perhaps have the art of pleasing,—provided
you do not abuse it. Well now, are you good enough girl and strong
enough woman to give me a little account of your past life? Have you had
some romance? Yes, you have,—have n't you? It is impossible that it
could have been otherwise? You are twenty-two or twenty-three years
old—"</p>
<p class="calibre11">"I am twenty-four, and I have had no other romance than the one of which
I am going to tell you in two words. At seventeen I was sought in
marriage by a person who pleased me, and who withdrew when he learned
that my father had left more debts than capital. I was very much
grieved, but I have forgotten it all, and I have sworn never to marry."</p>
<p class="calibre11">"Ah! that is spite, and not forgetfulness."</p>
<p class="calibre11">"No, Madame, that was an effort of the reason. Having nothing, but
believing myself to be something, I did not wish to make a foolish
marriage; and, far from having any spite, I have forgiven him who
abandoned me. I forgave him especially the day when, seeing my sister
and her four children in misery, I understood the sorrow of the father
of a family who dies with the pain of knowing that he can leave nothing
to his orphans."</p>
<p class="calibre11">"And you saw that ingrate again?"</p>
<p class="calibre11">"No, never. He is married, and I have ceased to think of him."</p>
<p class="calibre11">"And since then you have never thought of any other?"</p>
<p class="calibre11">"No, Madame."</p>
<p class="calibre11">"How have you done?"</p>
<p class="calibre11">"I do not know. I believe I have not had time to think of myself. When
one is very poor, and does not want to give up to misery, the days are
well filled out."</p>
<p class="calibre11">"But you have, nevertheless, been much sought after, pretty as you
are,—have you not?"</p>
<p class="calibre11">"No, Madame, no one has troubled me in that way. I do not believe in
persecutions which are not at all encouraged."</p>
<p class="calibre11">"I think as you do, and I am satisfied with your manner of answering. Do
you, then, fear nothing for yourself in the future?"</p>
<p class="calibre11">"I fear nothing at all."</p>
<p class="calibre11">"And will not this solitude of the heart make you sad or sullen?"</p>
<p class="calibre11">"I do not foresee it in any way. I am naturally cheerful, and I have
preserved my command over myself in the midst of the most cruel tests. I
have no dream of love in my head; I am not romantic. If I ever change I
shall be very much astonished. That, Madame, is all I can tell you about
myself. Will you take me such as I represent myself with confidence,
since I can after all but give myself out for what I know myself to be?"</p>
<p class="calibre11">"Yes, I take you for what you are,—an excellent young woman, full
of frankness and good-will. It remains to be seen whether you really have
the little attainments that I require."</p>
<p class="calibre11">"What must I do?"</p>
<p class="calibre11">"Talk, in the first place; and upon that point I am already satisfied.
And then you must read, and play a little music."</p>
<p class="calibre11">"Try me right away; and if the little I can do suits you—"</p>
<p class="calibre11">"Yes, yes," she said, putting a book into my hands, "do read; I want to
be enchanted with you."</p>
<p class="calibre11">At the end of a page she took the book away from me, with the remark
that my reading was perfect. Then came the music. There was a piano in
the room. She asked me if I could read at sight. As that is about all I
can do, I could satisfy her again on that point. Finally she told me
that, knowing my writing and my style of composition, from letters of
mine which Madame d'Arglade had shown her, she considered that I would
be an excellent secretary, and she dismissed me, giving me her
hand, and saying many kind things to me. I asked her for one
day—to-morrow—in order to see some people here with whom we are
acquainted, and she has given orders that I should be installed
Saturday.—</p>
<p class="calibre11">Dear sister, I have just been interrupted. What a pleasant surprise! It
is a note from Madame de Villemer,—a note of three lines, which I
transcribe for you:—</p>
<p class="calibre11">"Permit me, dear child, to send you a trifle on account, for your
sister's children, and a little dress for yourself. As you are fond of
dress we must humor the weaknesses of those we like. It is arranged and
understood that you are to have a hundred and fifty francs a month, and
that I take upon myself to keep you in clothes."</p>
<p class="calibre11">How good and motherly that is,—is it not? I see that I shall love
that woman with all my heart, and that I had not estimated her, at first
sight, as highly as she deserved. She is more impulsive than I thought.
The five hundred franc bill I enclose in this letter. Make haste! some
wood in the cellar, some woollen petticoats for Lili, who needs them,
and a chicken from time to time on that poor table. A little wine for
you; your stomach is quite shattered, and it will take so little to
restore it. The chimney must be repaired; it smokes atrociously: it is
unbearable; it may weaken the children's eyes,—and those of my little
girl are so beautiful!</p>
<p class="calibre11">Really, I am ashamed of the dress which is intended for me,—a
dress of magnificent pearl-gray silk. Ah, how foolish I was to say that I
liked to be well dressed! A dress for forty francs would have satisfied my
ambition, and here I am attired in one worth two hundred, while my poor
sister is repairing her rags. I do not know where to hide myself; but do
not at least think that I am humiliated by receiving a present. I shall
relieve my conscience of the burden of these kindnesses, my heart tells
me. You see, Camille, everything succeeds with me as soon as I enter
upon it. I light, the first thing, upon an excellent woman, I get more
than I had agreed to take, and I am received and treated as a child whom
it is desired to adopt and spoil. And then to think that you kept me
back a whole six months, imposing an increase of privations upon
yourself and tearing your hair at the idea of my working for you! Good
sister, were you not then a bad mother? Ought not those dear treasures
of children to have been considered above all things, and should they
not have silenced even our own regard for each other? Ah! I was very
much afraid of failure, nevertheless, I will confess to you now, when I
took out of the house our last few louis for the expenses of my journey,
at the risk of returning without having pleased this lady. God has been
concerned in it, Camille; I prayed to him this morning with such
confidence! I asked him so fervently to make me amiable, decorous, and
persuasive. Now I am going to bed, for I am overcome with fatigue. I
love you, my little sister, you know, more than anything else in the
world, and much more than myself. Do not grieve about me then; I am just
now the happiest girl that lives, and yet I am not with you and do not
see our children as they sleep! You see, indeed, that there is no true
happiness in selfishness, since, alone as I am, separated from all that
I love, my heart beats with joy in spite of my tears, and I am going to
thank God upon my knees before I fall asleep.</p>
<p class="calibre13">CAROLINE.</p>
<p class="calibre11">While Mlle de Saint-Geneix was writing to her sister, the Marchioness de
Villemer was talking with the youngest of her sons in her little
drawing-room in the Faubourg Saint-Germain. The house was large and
respectable; yet the Marchioness, formerly rich and now in very narrow
circumstances,—we shall soon see why,—had of late occupied the
second floor in order to turn the first to account.</p>
<p class="calibre11">"Well, dear mother," said the Marquis, "are you satisfied with your new
companion? Your people have told me that she has arrived."</p>
<p class="calibre11">"My dear child," answered the Marchioness, "I have but one word to say
of her, and that is that she has bewitched me."</p>
<p class="calibre11">"Really? Tell me about it."</p>
<p class="calibre11">"Upon my word, I am not too sure that I dare. I am afraid of turning
your head in advance."</p>
<p class="calibre11">"Fear nothing," was the sorrowful reply of the Marquis, whom his mother
had tried to win into a smile; "even if I were so easy to inflame, I
know too well what I owe to the dignity of your house and to the repose
of your life."</p>
<p class="calibre11">"Yes, yes, my friend; I know too that I can be at ease upon a question
of honor and delicacy, when it is with you that I have to do; I can also
tell you that the little D'Arglade has found for me a pearl, a diamond,
and that, to commence with, this phoenix has led me into follies."</p>
<p class="calibre11">The Marchioness gave an account of her interview with Caroline, and
described her thus: "She is neither tall nor short, she is well formed,
has pretty little feet, the hands of a child, abundant light blond hair,
a complexion of lilies and roses, perfect features, pearly teeth, a
decided little nose, large sea-green eyes, which look straight at you
unflinchingly, without dreaminess, without false timidity, with a candor
and a confidence which please and engage; nothing of a provincial, she
has manners which are excellent because they do not seem to be manners
at all; much taste and gentility in the poverty of her attire; in a
word, all that I feared and yet nothing that I feared, that is, beauty
which inspired me with distrust and none of the affectations and
pretensions which would have justified that distrust; and more, a voice
and pronunciation which make real music of her reading, sterling talent
as a musician, and, above all that, every indication of mind, sense,
discretion, and good-nature: to such an extent that, interested and
carried away by her devotion to a poor family to which I see plainly she
is sacrificing herself, I forgot my projects of economy, and have
engaged to give her the eyes out of my head."</p>
<p class="calibre11">"Has she been bargaining with you?" demanded the Marquis.</p>
<p class="calibre11">"Quite the contrary, she was satisfied to take what I had determined to
give her."</p>
<p class="calibre11">"In that case you did well, mother, and I am glad that you have at last
a companion worthy of you. You have kept too long that hungry and sleepy
old maid who worried you, and when you have a chance to replace her by a
treasure, you would do very wrong to count the cost."</p>
<p class="calibre11">"Yes," replied the Marchioness, "that's what your brother also says;
neither he nor you care to count the cost, my dear children, and I fear
I have been too hasty in the satisfaction which I have just given
myself."</p>
<p class="calibre11">"That satisfaction was necessary to you," said the Marquis with spirit,
"and you ought the less to reproach yourself with it since you have
yielded to your need of performing a good action."</p>
<p class="calibre11">"I acknowledge it, but I was wrong perhaps," replied the Marchioness,
with a careworn expression; "one has not always the right to be
charitable."</p>
<p class="calibre11">"Ah! my mother," cried the son, with a mingling of indignation and
sadness, "when you are forced to deny yourself the joy of giving alms,
the injury that I have done will be very great!"</p>
<p class="calibre11">"The injury! you? what injury?" rejoined the mother, astonished and
troubled; "you have never done an injury, my dear son."</p>
<p class="calibre11">"Pardon me," said the Marquis, greatly moved. "I was to blame the day I
engaged, out of respect to you, to pay my brother's debts."</p>
<p class="calibre11">"Hush!" cried the Marchioness, turning pale. "Let us not speak of that,
we would not understand each other." She extended her hands to the
Marquis to lessen the involuntary bitterness of this answer. The Marquis
kissed his mother's hands and retired shortly afterward.</p>
<p class="calibre11">The next day, Caroline de Saint-Geneix went out to mail with her own
hands the registered letter which she sent to her sister, and to see
some people from the remotest part of her province with whom she kept up
her acquaintance. These were old friends of her family, whom she did not
succeed in meeting, and she left her name without giving her address, as
she no longer had a home which she could consider her own. She felt a
species of sadness to think of herself thus lost and dependent in a
strange house; but she did not indulge in long reflections upon her
destiny. In addition to the fact that she refused once for all to
nourish in herself the least unnerving melancholy, she was not at all a
timid character, and any test, howsoever unpleasant, did not set her at
variance with life. There was in her organization an astonishing
vitality, an ardent activity, which was all the more remarkable because
it arose from great tranquillity of mind and from a singular absence of
thought about herself. This character, which is exceptional enough, will
develop and explain itself as much as we can make it do so, by the
events of the following narrative; but the reader must necessarily
remember, what all the world knows, that no one can explain completely
and set in an exact light the character of another. Every individual has
in the depth of his being a mystery of power or of weakness which he
himself can as little reveal as he can understand. Analysis should seem
satisfactory when it comes near to truth, but it could not seize the
truth in the fact without leaving some phase of the eternal problem of
the soul incomplete or obscure.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?3aee15eb